import { configureStore } from '@reduxjs/toolkit';

import actionTimeoutMiddleware from 'apps/web_forms/reduxMiddlewares/loadingMiddleware';
import rootReducer from 'apps/web_forms/reducers';

export default configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(actionTimeoutMiddleware),
});